module.exports = __webpack_public_path__ + "img/ma249.58315efa.png";